const templates =  {
    "shop.okraina.ru": {
        title: "Настройки пользователя",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Настройки пользователя",
        tags: [

        ]
    },
}

export default templates;